// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"newsletter_newsletter__WEjcJ"};